import { render, staticRenderFns } from "./InfoPaciente.vue?vue&type=template&id=64f7f8be"
import script from "./InfoPaciente.vue?vue&type=script&lang=js"
export * from "./InfoPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports